import { TNFTContent } from '@cyber/service/api';
import { NftFragment } from '@cyber/service/pwa';

export default function getUniqueNFTId(nft: NftFragment | TNFTContent) {
  return 'token_id' in nft ? `${nft.contract_address}-${nft.token_id}` : `${nft.contract}-${nft.tokenId}`;
}
